module.exports = __webpack_public_path__ + "img/2.ec3e867b.jpg";